// Build the complete next list without mutating selections. A failed lookup must not
// silently drop a selection or allow navigation while area options are loading.
export const buildAddedGeographicAreas = ({
    addedAreas, selectedType, selectedCountries, selectedRegions,
    selectedCities, selectedCounties, countries, regions, cities, countyOptions,
    isUs, extractRegion,
}) => {
    const newItems = [];
    if (selectedType === "entire") {
        selectedCountries.forEach((country) => {
            const countryObj = countries.find(
                (s) => s.description === country
            );

            if (!countryObj) throw new Error("Area options are not ready");
            const id = "country-" + countryObj.code;
            if (addedAreas.findIndex((a) => a.id === id) === -1) {
                newItems.push({
                    id,
                    scope: "country",
                    country: countryObj.description,
                });
            }
        });
    } else {
        selectedRegions.forEach((provinceCode) => {
            const provinceObj = regions.find(
                (s) => s.code === provinceCode
            );
            if (!provinceObj) throw new Error("Area options are not ready");
            const id = "region-" + provinceCode;
            if (addedAreas.findIndex((a) => a.id === id) === -1) {
                newItems.push({
                    id,
                    scope: "region",
                    country: isUs ? "United States" : "Canada",
                    region: provinceObj.description,
                });
            }
        });

        selectedCities.forEach((city) => {
            const cityObj = cities.find((c) => c.value === city);

            if (!cityObj) throw new Error("Area options are not ready");
            const id =
                "city-" + cityObj.value + "-" + cityObj.secondaryAction;
            if (addedAreas.findIndex((a) => a.id === id) === -1) {
                newItems.push({
                    id:
                        "city-" +
                        cityObj.value +
                        "-" +
                        cityObj.secondaryAction,
                    scope: "city",
                    country: isUs ? "United States" : "Canada",
                    region: extractRegion(
                        cityObj.secondaryAction
                    ),
                    city: cityObj.value,
                });
            }
        });

        selectedCounties.forEach((key) => {
            const countyObj = countyOptions.find((c) => c.key === key);
            if (!countyObj) throw new Error("Area options are not ready");

            const id = "county-" + countyObj.stateCode + "-" + countyObj.value;
            if (addedAreas.findIndex((a) => a.id === id) === -1) {
                newItems.push({
                    id,
                    scope: "county",
                    country: isUs ? "United States" : "Canada",
                    region: countyObj.region,
                    county: countyObj.value,
                });
            }
        });

    }

    return [...addedAreas, ...newItems];
};
